module.exports = __webpack_public_path__ + "media/images/products/home2-a0549202b18913380ec9555ef9d497b0.png";